const LEGACY_COOKIE = 'userInfo';

// Admins and advertisers used to stay signed in through a long-lived
// `userInfo` cookie holding a backend access token. Firebase replaces it, so
// it is dropped on first load and everyone signs in once more.
export function discardLegacySession(cookies) {
  if (cookies.get(LEGACY_COOKIE)) {
    cookies.remove(LEGACY_COOKIE, { path: '/' });
  }
}
